import React from "react";
const TestPage = (props) => {

    console.log("Test Page Props", props);
    if (props.env === "staging") {
        return(
            <React.Fragment>
                <div className="w-10/12 mx-auto flex justify-between">
                <button className="primary-button">Primary Button</button> 
                <button className="secondary-button">Secondary Button</button>
                </div>
                
            </React.Fragment>
        )
    }
    
}
export { TestPage }
// export default TestPage;